import { Card, Text, Group, Stack, Divider, Badge } from "@mantine/core";
import { useCallback, useEffect, useState } from "react";
import { getSectionFeature } from "src/apis/chartAPI";
import { useModal } from "src/context/ModalContext";
import { convertDeepToCamelCase } from "src/utils/utils";
import { featureTypeToTitle } from "src/variable/constant";
import { formatMetricRange } from "./timeRange";

export interface FeatureUsageResponse {
  summary: Summary;
  featureBreakdown: FeatureBreakdownItem[];
  dateRange: DateRange;
}

export interface Summary {
  totalEvents: number;
  mostUsedFeature: string;
  mostUsedFeatureEvents: number;
}

export interface FeatureBreakdownItem {
  featureType: string;
  count: number;
  percentage: number;
}

export interface DateRange {
  start: string; // ISO string
  end: string;   // ISO string
  days: number;
}

export type FeatureUsageItem = {
  label: string;
  value: number; // %
};

export function TopFeatureUsageCard() {
  const [data, setData] = useState<FeatureUsageResponse>();

  const { openError } = useModal()

  const handleGetSectionFeatures = useCallback(async () => {
    try {
      const res = await getSectionFeature({})
      if (res) {
        const { object } = res?.data?.results || []
        // console.log(object);
        const data = convertDeepToCamelCase<FeatureUsageResponse>(object)
        // console.log(data);
        setData(data)

        // setSessionEngagement(data)
      }
    } catch (error) {
      openError(error)
    }
  }, [openError])
  useEffect(() => {
    handleGetSectionFeatures()
  }, [handleGetSectionFeatures])
  return (
    <Card withBorder radius="md" p="lg">
      <Stack spacing="md">

        <Badge color="red" size="lg" radius="md">
          TOP FEATURE USAGE
        </Badge>
        <Text size="xs" color="dimmed">
          Last {data?.dateRange?.days || '-'} days: {formatMetricRange(data?.dateRange)}
        </Text>
      </Stack>
      <Divider my="md" />

      {/* <Divider my="md" /> */}

      <Stack spacing={12}>
        {data?.featureBreakdown.sort((a, b) => b.percentage - a.percentage).map((item) => (
          <Group key={item.featureType} position="apart">
            <Text size="sm">{featureTypeToTitle(item.featureType)}</Text>
            <Text size="sm" weight={800}>
              {item.percentage}%
            </Text>
          </Group>
        ))}
      </Stack>
    </Card>
  );
}
